import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { User, Briefcase, Phone, UserCircle, Database, History, FileText } from 'lucide-react';

const PortalPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="bg-[#1a1a1a] py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Grain Portal</h1>
            <p className="text-gray-300 max-w-2xl mx-auto">
              Access your account information, storage details, and more.
            </p>
          </div>
        </section>

        {/* Portal Access Cards */}
        <section className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              {/* Grower Portal */}
              <div className="bg-[#faf8f5] rounded-lg p-8 text-center">
                <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <User className="w-8 h-8 text-white" />
                </div>
                <h2 className="text-xl font-bold text-gray-900 mb-2">Grower Portal</h2>
                <p className="text-gray-600 mb-6">
                  Access your account information and storage details
                </p>
                <a
                  href="https://portal.wychegrain.com.au/?NGRLogin"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="grower-portal-login-link"
                  className="inline-block px-6 py-3 bg-yellow-500 text-white font-semibold rounded-md hover:bg-yellow-600 transition-colors w-full"
                >
                  Grower Portal Login
                </a>
              </div>

              {/* Trader Portal */}
              <div className="bg-[#faf8f5] rounded-lg p-8 text-center">
                <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Briefcase className="w-8 h-8 text-white" />
                </div>
                <h2 className="text-xl font-bold text-gray-900 mb-2">Trader Portal</h2>
                <p className="text-gray-600 mb-6">
                  Access your trading account and transaction history
                </p>
                <a
                  href="https://portal.wychegrain.com.au/?TraderLogin"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="trader-portal-login-link"
                  className="inline-block px-6 py-3 bg-yellow-500 text-white font-semibold rounded-md hover:bg-yellow-600 transition-colors w-full"
                >
                  Trader Portal Login
                </a>
              </div>
            </div>

            {/* Need Assistance */}
            <div className="text-center">
              <p className="text-gray-700 mb-2">Need assistance?</p>
              <a
                href="tel:+61354937444"
                className="inline-flex items-center gap-2 text-yellow-600 font-semibold hover:text-yellow-700"
              >
                <Phone size={18} />
                Call us at +61 3 5493 7444
              </a>
            </div>
          </div>
        </section>

        {/* Portal Features */}
        <section className="py-16 bg-[#faf8f5]">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center">Portal Features</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {/* Account Information */}
              <div className="bg-white rounded-lg p-6 text-center">
                <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <UserCircle className="w-6 h-6 text-yellow-600" />
                </div>
                <h3 className="font-bold text-gray-900 mb-2">Account Information</h3>
                <p className="text-gray-600 text-sm">
                  View and manage your account details and contact information.
                </p>
              </div>

              {/* Storage Details */}
              <div className="bg-white rounded-lg p-6 text-center">
                <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Database className="w-6 h-6 text-yellow-600" />
                </div>
                <h3 className="font-bold text-gray-900 mb-2">Storage Details</h3>
                <p className="text-gray-600 text-sm">
                  Track your grain storage, volumes, and current inventory.
                </p>
              </div>

              {/* Transaction History */}
              <div className="bg-white rounded-lg p-6 text-center">
                <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <History className="w-6 h-6 text-yellow-600" />
                </div>
                <h3 className="font-bold text-gray-900 mb-2">Transaction History</h3>
                <p className="text-gray-600 text-sm">
                  Access your complete transaction and delivery history.
                </p>
              </div>

              {/* Documents & Reports */}
              <div className="bg-white rounded-lg p-6 text-center">
                <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <FileText className="w-6 h-6 text-yellow-600" />
                </div>
                <h3 className="font-bold text-gray-900 mb-2">Documents & Reports</h3>
                <p className="text-gray-600 text-sm">
                  Download statements, receipts, and other important documents.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PortalPage;
